import React, { FC } from "react";
import { useGetN400PaySuccess } from "../../../../hooks/n400/useN400";
import { useSearchParams } from "react-router-dom";
import PaySuccess from "../../components/PaySuccess";

interface Props {
  formType: string;
}

const N400PaySuccess: FC<Props> = ({ formType }) => {
  const [searchParams] = useSearchParams();
  const payId = searchParams.get("payId") as string;
  const { isLoading, isError } = useGetN400PaySuccess(payId);

  return (
    <PaySuccess isLoading={isLoading} isError={isError} formType={formType} />
  );
};

export default N400PaySuccess;
